/** @file World point under a pointer sample. */
import { viewCamera } from '@pose2d/editor-geometry/viewCamera';
import type { Vec2 } from '@pose2d/math/types';
import type { ToolContext, ViewportPointer } from './viewportTypes';

/** viewCamera.screenToWorld of the context camera, into a new Vec2. */
export function worldAt(ctx: Pick<ToolContext, 'camera'>, p: Pick<ViewportPointer, 'sx' | 'sy'>): Vec2 {
  return viewCamera.screenToWorld(ctx.camera, p.sx, p.sy, [0, 0]);
}
